<script>
	import CartList from './CartList.svelte';
</script>

<div class="cart-menu">
	<h1 class="cart-menu-title">Your Cart</h1>
	<CartList  compact={true} />
	<a class="btn btn-expanded" href="/cart">Go to Cart</a>
</div>

<style>
	.cart-menu{
		padding: var(--spacing-sm);
		padding-top: 0;
	}
	.cart-menu-title{
		margin: 0;
		font-size: var(--font-size);
		line-height: calc(var(--line-height) * 2);
	}
	.cart-menu .btn{
		margin-top: var(--spacing-sm);
	}
</style>
